export const initialReorderingState = {
  direction: null,
  draggingItemSize: null,
  fromIndex: null,
  orientation: 'horizontal',
  phase: 'idle',
  toIndex: null
};
export function reorderingReducer(state, action) {
  switch (action.type) {
    case 'start-dragging':
      {
        const {
          fromIndex,
          itemSize
        } = action.payload;
        return Object.assign({}, state, {
          phase: 'dragging',
          fromIndex,
          // Don't replace dragged item with placeholder immediately,
          // we need a short delay to let React DnD set up the drag layer,
          // which we achieve by setting dispatching the set-initial-placeholder
          // action in a requestAnimationFrame callback.

          toIndex: null,
          draggingItemSize: itemSize
        });
      }
    case 'set-initial-placeholder':
      {
        const {
          toIndex
        } = action.payload;
        return Object.assign({}, state, {
          toIndex
        });
      }
    case 'update-drop-target':
      {
        const {
          toIndex
        } = action.payload;
        if (state.fromIndex == null || state.fromIndex === toIndex) {
          return state;
        }
        const direction = getDirection(state.fromIndex, toIndex, state.orientation);
        return Object.assign({}, state, {
          toIndex,
          direction
        });
      }
    case 'update-drag-state':
      {
        const {
          dropTarget
        } = action.payload;
        if (dropTarget !== undefined) {
          const direction = state.fromIndex != null && dropTarget != null && state.fromIndex !== dropTarget ? getDirection(state.fromIndex, dropTarget, state.orientation) : state.direction;
          return Object.assign({}, state, {
            toIndex: dropTarget,
            direction
          });
        }
        return state;
      }
    case 'end-dragging':
      {
        return Object.assign({}, state, {
          phase: 'idle',
          fromIndex: null,
          toIndex: null,
          direction: null,
          draggingItemSize: null
        });
      }
    default:
      return state;
  }
}
function getDirection(fromIndex, toIndex, orientation) {
  if (fromIndex === toIndex) return null;
  const increasingDirection = orientation === 'horizontal' ? 'right' : 'down';
  const decreasingDirection = orientation === 'horizontal' ? 'left' : 'up';
  return toIndex > fromIndex ? increasingDirection : decreasingDirection;
}